export { default as saga } from "./saga"

export const name = `notificationDirector`
export const reducer = (state = {}) => state
